import { cn } from "lib/utils";
import React from "react";

import arrowLeft from "assets/images/totem/arrow-left.svg";
import arrowRight from "assets/images/totem/arrow-right.svg";

type ActionButtonProps = {
	children: React.ReactNode;
	variant?: "primary" | "secondary";
	direction?: "forward" | "back";
	onClick?: () => void;
	className?: string;
	iconSrc?: string;
	loading?: boolean;
	loadingText?: string;
};

export const ActionButton: React.FC<ActionButtonProps> = ({
	children,
	variant = "primary",
	direction = "forward",
	onClick,
	className,
	iconSrc,
	loading = false,
	loadingText = "Carregando...",
}) => (
	<button
		type="button"
		onClick={onClick}
		disabled={loading}
		aria-busy={loading}
		className={cn(
			"flex h-[112px] w-full items-center gap-4 overflow-hidden rounded-[4px] px-10 text-left transition-colors max-[1023px]:h-24 max-[1023px]:px-8 max-[1023px]:text-[28px] max-[639px]:h-[53px] max-[639px]:gap-2 max-[639px]:px-4",
			variant === "primary" && "bg-[#155DFC] hover:bg-[#104bd0]",
			variant === "secondary" && "bg-[#4A5565] hover:bg-[#39424f]",
			loading && "cursor-wait opacity-90",
			className,
		)}
	>
		{direction === "back" && (
			<span
				className={cn(
					"flex h-[48px] w-[48px] shrink-0 items-center justify-center max-[639px]:h-8 max-[639px]:w-8",
				)}
			>
				<img
					src={arrowLeft}
					alt=""
					className={cn(
						"block h-[48px] w-[48px] rotate-180 max-[639px]:h-8 max-[639px]:w-8",
					)}
				/>
			</span>
		)}
		<span
			className={cn(
				"min-w-0 flex-1 font-GilroyBold text-[32px] leading-normal text-white max-[1023px]:text-[28px] max-[639px]:text-[16px]",
				direction === "back" && "text-right",
			)}
		>
			{loading ? loadingText : children}
		</span>
		{direction !== "back" && (
			<span
				className={cn(
					"flex h-[48px] w-[48px] shrink-0 items-center justify-center max-[639px]:h-8 max-[639px]:w-8",
				)}
			>
				{loading ? (
					<span
						aria-hidden="true"
						className={cn(
							"block h-7 w-7 animate-spin rounded-full border-4 border-white/40 border-t-white max-[639px]:h-5 max-[639px]:w-5",
						)}
					/>
				) : (
					<img
						src={iconSrc || arrowRight}
						alt=""
						className={cn(
							"block h-[48px] w-[48px] max-[639px]:h-8 max-[639px]:w-8",
						)}
					/>
				)}
			</span>
		)}
	</button>
);
